import React from 'react';
import queryString from 'query-string';
import { useLocation } from '@gatsbyjs/reach-router';
import { SelectorContent, useSelectorMachineContext } from '@printdeal/product-selector';
import { useSelector as useReduxSelector } from 'react-redux';
import { DELIVERY_TOOLS } from '@printdeal/business-logic';
import type { IProductPage } from '../../../../../types/product/productDetailPage';
import FSCInfo from '../../../detail/advanced/summary/FSCInfo';
import ProductUnavailableAlert from '../ProductUnavailableAlert';
import SelectorError from '../SelectorError';
import PriceSection from '../DefaultValues/PriceSection';
import SubmitButtons from '../SubmitButtons';
import { RootState } from '../../../../../store';
import TechnicalDrawingModal from '../Modals/TechnicalDrawingModal';
import { CutOffTime } from '../CutOffTime';
import { SelectedDeliveryTool } from '../../../../../types/file-delivery/FileDelivery';

interface Props {
  pageContent: IProductPage;
  selector: SelectorContent,
  productPageId: string;
}

export const ReviewPageProductSummary = ({
  pageContent, selector, productPageId,
}: Props) => {
  const location = useLocation();
  const { query } = queryString.parseUrl(location.href);
  const productAttributes = useSelectorMachineContext((state) => state.context.productAttributes);
  const selectorSelection = useSelectorMachineContext((state) => state.context.selection);
  const groupSelection = useSelectorMachineContext((state) => state.context.group);
  const totalQuantity = useSelectorMachineContext((state) => state.context.totalQuantity);

  const customerGroupId = useReduxSelector<RootState, string | undefined>(
    // @ts-expect-error - The customer slice needs to be converted to typescript
    ({ customer }) => customer?.customer?.customerGroup?.id,
  );

  return (
    <>
      <FSCInfo productAttributes={{ validationVersion: 1, attributes: productAttributes || [] }} />
      <CutOffTime />
      <ProductUnavailableAlert
        contentfulId={productPageId}
        product={selector.product}
        currentSelection={selectorSelection}
        totalQuantity={totalQuantity || 0}
        groupSelection={groupSelection}
      />

      <SelectorError contentfulId={productPageId} />

      <PriceSection customerGroupId={customerGroupId} />

      <SubmitButtons
        selector={selector}
        attributes={selector.configuration.attributes}
        pageContent={pageContent}
        selectedDeliveryTool={(query.editorType === DELIVERY_TOOLS.UPLOADER_TOOL) ? DELIVERY_TOOLS.UPLOADER_TOOL as SelectedDeliveryTool : 'editor'}
      />

      <div className="pd-mt-5 pd-flex pd-items-center pd-justify-center">
        <TechnicalDrawingModal productPage={pageContent} variant={selector.configuration.variantSku} />
      </div>
    </>
  );
};
